<script lang="ts">
    import { getDashboardCtx } from "../state/dashboard.svelte";
    import { translate } from "@/utils/format";
    import { NoData } from "@/components";

    const store = getDashboardCtx();
    import SectionHeader from "../components/SectionHeader.svelte";
    import StripeGate from "../components/StripeGate.svelte";
</script>

<div class="dashStack">
    <SectionHeader id="subscriptions" />
    <div class="referralsPanel">
    {#if store.isStripeConfigured}
<div
    class="referralsPanel__toolbar referralsPanel__toolbar--metrics"
>
    <div class="periodBar">
        <span class="periodBar__label">
            {translate("PARTNER_PERIOD", "Periodo")}:
            <strong>{store.rangeDaysLabel}</strong>
        </span>
        <span
            class="periodBar__updated"
            title={store.lastMetricsUpdatedAt
                ? store.formatDateTime(store.lastMetricsUpdatedAt)
                : translate(
                      "PARTNER_LAST_UPDATED_UNKNOWN",
                      "Sin datos todavía",
                  )}
        >
            {#if store.lastMetricsUpdatedAt}
                {translate(
                    "PARTNER_LAST_UPDATED",
                    "Actualizado",
                )}
                {" "}
                {store.relativeTime(store.lastMetricsUpdatedAt)}
            {:else}
                {translate(
                    "PARTNER_LAST_UPDATED_UNKNOWN",
                    "Sin datos todavía",
                )}
            {/if}
        </span>
    </div>

    <div
        class="rangePicker"
        aria-label={translate("PARTNER_PERIOD", "Periodo")}
    >
        <button
            type="button"
            class={store.range === "7d" ? "isActive" : ""}
            onclick={() => {
                store.range = "7d";
                void store.loadMetrics();
            }}
        >
            7
        </button>
        <button
            type="button"
            class={store.range === "30d" ? "isActive" : ""}
            onclick={() => {
                store.range = "30d";
                void store.loadMetrics();
            }}
        >
            30
        </button>
        <button
            type="button"
            class={store.range === "90d" ? "isActive" : ""}
            onclick={() => {
                store.range = "90d";
                void store.loadMetrics();
            }}
        >
            90
        </button>
        <button
            type="button"
            class={store.range === "all" ? "isActive" : ""}
            onclick={() => {
                store.range = "all";
                void store.loadMetrics();
            }}
        >
            {translate("PARTNER_PERIOD_ALL_SHORT", "Total")}
        </button>
    </div>
</div>

<div class="kpiGrid kpiGrid--3">
    <div class="kpi">
        <div class="kpi__value">{store.subsActive}</div>
        <div class="kpi__label">
            {translate(
                "LANG_PARTNER_SUBS_ACTIVE",
                "Activas",
            )}
        </div>
    </div>
    <div class="kpi">
        <div class="kpi__value">{store.subsTrial}</div>
        <div class="kpi__label">
            {translate("STATUS_TRIAL", "En prueba")}
        </div>
    </div>
    <div class="kpi">
        <div class="kpi__value">{store.subsPastDue}</div>
        <div class="kpi__label">
            {translate(
                "LANG_PARTNER_SUBS_PAST_DUE",
                "Impagos",
            )}
        </div>
    </div>
</div>

<div class="grid2">
    <div class="panelCard">
        <div class="panelCard__title">
            {translate(
                "PARTNER_UPCOMING_RENEWALS",
                "Próximas renovaciones",
            )}
        </div>
        <div class="rows">
            {#if store.renewSoon.length > 0}
                {#each store.renewSoon as s (s.id)}
                    <div class="row">
                        <span class="mono"
                            >{s.emailMasked}</span
                        >
                        <span
                            class={`badge badge--${s.status}`}
                            >{store.formatStatus(s.status)}</span
                        >
                        <span class="right"
                            >{store.formatShortDay(
                                s.renewAt,
                            )}</span
                        >
                    </div>
                {/each}

                {#if store.subscriptionsList.length > store.renewSoon.length}
                    <button
                        type="button"
                        class="linkButton"
                        onclick={() =>
                            document
                                .getElementById(
                                    "subscriptionsTable",
                                )
                                ?.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start",
                                })}
                    >
                        {translate(
                            "PARTNER_VIEW_ALL",
                            "Ver todas",
                        )}
                    </button>
                {/if}
            {:else}
                <NoData
                    params={{
                        icon: "fa-calendar",
                        title: translate(
                            "EMPTY_STATE_NO_SUBSCRIPTIONS",
                            "Sin suscripciones",
                        ),
                        description: translate(
                            "LANG_PARTNER_NO_SUBS_DESC",
                            "Cuando haya suscripciones asociadas a tu enlace aparecerán aquí.",
                        ),
                    }}
                />
            {/if}
        </div>
    </div>

    <div class="panelCard">
        <div class="panelCard__title">
            {translate(
                "PARTNER_PERIOD_INDICATORS",
                "Indicadores del periodo",
            )}
        </div>
        <div class="summaryList">
            <div class="summary">
                <span>
                    {translate(
                        "LANG_PARTNER_SUBS_CANCELED",
                        "Canceladas",
                    )}
                </span>
                <strong>{store.subsCanceled}</strong>
            </div>
            <div class="summary">
                <span>
                    {translate(
                        "PARTNER_CONVERSION_PERIOD",
                        "Conversión del periodo",
                    )}
                </span>
                <strong
                    >{store.formatPercent(
                        store.conversionRange,
                        1,
                    )}</strong
                >
            </div>
            <div class="summary">
                <span>
                    {translate("PARTNER_PERIOD", "Periodo")}
                </span>
                <strong>{store.rangeDaysLabel}</strong>
            </div>
        </div>
    </div>
</div>

<div class="panelCard">
    <div class="panelCard__title">
        {translate(
            "LANG_PARTNER_SUBS_TABLE",
            "Listado de suscripciones",
        )}
    </div>
    {#if store.metricsHasSubscriptions}
        <div class="tableLike">
            <div class="tableLike__head">
                <span
                    >{translate(
                        "LANG_PARTNER_COL_USER",
                        "Usuario",
                    )}</span
                >
                <span
                    >{translate(
                        "LANG_PARTNER_COL_STATUS",
                        "Estado",
                    )}</span
                >
                <span
                    >{translate(
                        "LANG_PARTNER_COL_PLAN",
                        "Plan",
                    )}</span
                >
                <span class="right">
                    {translate(
                        "LANG_PARTNER_COL_RENEW",
                        "Renueva",
                    )}
                </span>
            </div>
            <div class="tableLike__body">
                {#each store.subscriptionsList as s (s.id)}
                    <div class="tableLike__row">
                        <span class="mono"
                            >{s.emailMasked}</span
                        >
                        <span
                            class={`badge badge--${s.status}`}
                            >{store.formatStatus(s.status)}</span
                        >
                        <span>{s.plan}</span>
                        <span class="right"
                            >{store.formatShortDay(
                                s.renewAt,
                            )}</span
                        >
                    </div>
                {/each}
            </div>
        </div>
    {:else}
        <NoData
            params={{
                icon: "fa-users",
                title: translate(
                    "LANG_PARTNER_NO_SUBS_TITLE",
                    "Sin suscripciones atribuidas",
                ),
                description: translate(
                    "LANG_PARTNER_NO_SUBS_DESC",
                    "Cuando haya suscripciones asociadas a tu enlace aparecerán aquí.",
                ),
            }}
        />
    {/if}
    <div class="panelCard__footer">
        <button
            class="button --primary"
            onclick={store.goStripePanel}
        >
            {translate(
                "LANG_PARTNER_OPEN_STRIPE",
                "Abrir Stripe",
            )}
        </button>
    </div>
</div>
    {:else}
        <StripeGate />
    {/if}
    </div>
</div>
